/**
 * Opens the lightbox for the links Xhtml::largeImageLink() renders. Call it on
 * every page that shows wiki markup; a second call does nothing.
 */
declare global {
   interface Window {
      // The renderer's inline onclick opens its popup only while this is unset.
      lightboxImageClicksBound?: boolean;
   }
}

export function bindLightboxImageClicks() {
   if (window.lightboxImageClicksBound) {
      return;
   }
   window.lightboxImageClicksBound = true;
   document.addEventListener('click', async event => {
      const trigger = event.target instanceof Element && event.target.closest('.js-lightbox-image');
      if (!(trigger instanceof HTMLElement) || !trigger.dataset.lightboxSrc) {
         return;
      }
      // A modified click keeps the link's own new-tab and new-window handling.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
         return;
      }
      event.preventDefault();
      // Transitional, like img.hasLarge in wiki.less: renders cached before the link
      // wrapper put the class on the img itself. Delete it and its test with that rule.
      const img = trigger instanceof HTMLImageElement ? trigger : trigger.querySelector('img');
      const { openImageLightbox } = await import('Shared/ImageLightbox');
      openImageLightbox(trigger.dataset.lightboxSrc, img?.currentSrc);
   });
}
